"use strict";

jQuery(document).ready(function ($) {
  $('.hero__image-carousel').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true
  });
});